import { apiClient } from "../config";

async function bulkInvitation(params: any) {
  const res = await apiClient.put(`/admin/users/bulk-emails`,params);
  return res.data;
}

export default bulkInvitation;
